import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getInstitutionAccounts, getAccountTransactions} from '../actions/transactionActions';
import utils from '../helpers/utils';
import _get from 'lodash/get';
import dateUtils from '../helpers/dateUtils';
import {RootState} from '../reducers/rootReducer';
import {hasAvailableInstitution} from '../helpers/transactionHelper';
import {TXM_DEFAULT_LOOK_BACK, TXM_DEFAULT_LOOK_BACK_JP} from '../constants/durations';
import {InstitutionAccountsResponse} from '../reducers/transactionReducers';

/**
 * Custom hook to handle transaction data fetching
 * @returns Transaction data methods
 */
export const useTransactions = () => {
  const dispatch = useDispatch();
  const auth = useSelector((store: RootState) => store.auth);
  const accountId = _get(auth, 'user.primaryMember.accountId', '');

  /**
   * Fetches the Txm data.
   */
  const fetchTxmData = useCallback(() => {
    const productFeatures = _get(auth, 'user.primaryMember.plan.productFeatures', null);
    const whiteLabelClient = _get(auth, 'whiteLabelClient', '');
    const showTxmUpgrade = utils.isTxmUpgradeScenario(productFeatures, whiteLabelClient);
    const primaryMember = _get(auth, 'user.primaryMember', null);

    if (!showTxmUpgrade && utils.showTransactions(primaryMember)) {
      const defaultLookBack = utils.isTxmJpAvailable(productFeatures)
        ? TXM_DEFAULT_LOOK_BACK_JP
        : TXM_DEFAULT_LOOK_BACK;
      const transactionArgs = {
        startDate: dateUtils.getStartDate(defaultLookBack),
        endDate: dateUtils.getEndDate(),
        sortField: 'postedDate',
        institutionId: '',
        accountId: '',
        offset: '',
        sortOrder: '',
        memberId: '',
        rowsToRetrieve: '',
      };

      return dispatch(getInstitutionAccounts({}, accountId)).then((response: InstitutionAccountsResponse) => {
        if (hasAvailableInstitution(response)) {
          return dispatch(getAccountTransactions(transactionArgs, accountId));
        }
      });
    }
  }, [auth, dispatch, accountId]);

  return {
    fetchTxmData,
  };
};
